import { AllSubjectExtent } from './AllSubjectExtent';
export default AllSubjectExtent;
